import React, { useState, useEffect } from "react";
import _ from "lodash";
import Booking from "../components/Steps/Booking";
import { Spin, Button } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import History from "../components/Steps/History";
import PaymentResult from "../components/Steps/PaymentResult";

import useScreen from "../hooks/useScreen";
import DesktopBooking from "../components/DesktopSteps/DesktopBooking";
import DesktopHistory from "../components/DesktopSteps/DesktopHistory";
import DesktopPaymentResult from "../components/DesktopSteps/DesktopPaymentResult";
import DesktopFooter from "../components/DesktopSteps/DesktopFooter";

const Home = ({ token }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const { width } = useScreen();
  const isDesktop = width >= 1024;

  useEffect(() => {
    hanleProcessPaymentReturn();
  }, [location, history, token]);

  const hanleProcessPaymentReturn = async () => {
    const queryParams = new URLSearchParams(location.search);
    const amount = queryParams.get("amount");
    const payment_type = queryParams.get("payment_type");
    const reference_number = queryParams.get("reference_number");
    const status = queryParams.get("status");
    const trans_ref_no = queryParams.get("trans_ref_no");
    const website_id = queryParams.get("website_id");
    const signature = queryParams.get("signature");

    // http://localhost:3000/booking-hotel?amount=2200000&message=&payment_type=VTCPAY&reference_number=IPASSTHOTEL1506C9C9&status=1&trans_ref_no=3570138&website_id=199760&signature=EDD75983BD81CA2B0F9FF8DABE4A17BFDE7B1449E10DA9E8D852F6EEB94C451B

    if (
      amount &&
      payment_type &&
      reference_number &&
      status &&
      trans_ref_no &&
      website_id &&
      signature
    ) {
      setStep("payment-result");
    } else if (location.pathname === "/history") {
      setStep("history");
    } else if (!step && token) {
      setStep("booking");
    }
  };

  useEffect(() => {
    if (location.pathname === "/history") {
      setStep("history");
    } else if (location.pathname === "/booking-hotel" && step !== "payment-result") {
      setStep("booking");
    }
  }, [location.pathname, step]);

  return (
    <Spin tip="Tải dữ liệu..." size="large" spinning={loading}>
      {/* {isDesktop ? (
        <div className="bg-[#f9f9f9] min-h-screen flex flex-col">
          <div className="flex-1">
            {step === "booking" && (
              <DesktopBooking
                setLoading={setLoading}
                loading={loading}
                setStep={setStep}
              />
            )}
            {step === "history" && (
              <DesktopHistory
                setStep={setStep}
                setLoading={setLoading}
                loading={loading}
              />
            )}
            {step === "payment-result" && (
              <DesktopPaymentResult
                setLoading={setLoading}
                loading={loading}
                setStep={setStep}
              />
            )}
          </div>
          <DesktopFooter />
        </div>
      ) : ( */}
      <div className="bg-[#f9f9f9] min-h-screen">
        <div className="w-full absolute top-0 z-[0] text-center pointer-events-none">
          <img src="/images/bg-form.png" className="w-full" alt="" />
        </div>
        <div className="z-10 flex items-center justify-between relative">
          {step === "booking" ? (
            <div className="w-[67px] h-8"></div>
          ) : (
            <div className="w-[67px] ml-4">
              <Button
                className="text-[14px] mt-[25px]"
                icon={<LeftOutlined color="#1677ff" />}
                onClick={() => {
                  history.push("/booking-hotel");
                }}
              />
            </div>
          )}
          {step === "booking" ? (
            <div className="z-10 inline-block p-5 cursor-pointer">
              <img
                onClick={() => {
                  history.push("/history");
                }}
                className="w-[32px] p-1 h-[32px] bg-white rounded-full"
                src={"/images/history.svg"}
                alt=""
              />
            </div>
          ) : (
            <div className="w-[67px] h-8"></div>
          )}
        </div>
        {step === "booking" && (
          <Booking
            setLoading={setLoading}
            loading={loading}
            setStep={setStep}
          />
        )}
        {step === "history" && (
          <History
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
          />
        )}
        {step === "payment-result" && (
          <PaymentResult setLoading={setLoading} loading={loading} />
        )}
      </div>
      {/* )} */}
    </Spin>
  );
};

export default Home;
